import { ILinkedServiceTypeMetadata } from 'app/extensibility/metadatas/resource-type/linked-service-type-metadata';

import { ShopifyCopySource } from 'app/model/pipeline/copysource/shopify.copysource';
import { ShopifyLinkedService } from 'app/model/linkedservice/shopify.linkedservice';
import { Metamodel } from 'app/model/base/model';
import { useEncryptedEndpointsRadioSwitch } from 'app/registries/linked-service/linked-service-shared-fields';
import { format } from 'app/shared/utils/string.util';

import { GlobalVariables } from 'app/services/globals';
import { driverVersionVersionOptions, driverVersions } from '../consts/tabular-consts';
import { ControlMetadata } from 'app/extensibility/metadatas/control/control-metadata';
import { DataSourceOptionKind, CommonResourceKind as ResourceKind } from '@powerquery/mashup-editor-client';

const connectionForm: ControlMetadata[] = [
        {
            type: 'textbox',
            bind: 'host',
            label: stringResources.ModelName_Host,
            required: true,
            placeholder: stringResources.Shopify_LinkedService_Host_Placeholder,
            validators: [
                { type: 'required', errorMessage: '' }
            ],
            isLabelVertical: true
        },
        {
            type: 'dynamic-akv-switcher',
            bind: 'accessToken',
            label: stringResources.ModelName_AccessToken,
            child: {
                type: 'password',
                label: stringResources.ModelName_AccessToken,
                isLabelVertical: true,
                required: true
            },
            validators: [
                { type: 'required', errorMessage: '' }
            ],
            description: format(stringResources.AzureKeyVaultSecretName_Tooltip_Template,
                format(stringResources.ModelName_LinkedServiceTemplate, stringResources.Shopify_DisplayText),
                stringResources.ModelName_AccessToken)
        }
    ]
export const shopifyMetadata: ILinkedServiceTypeMetadata = {
    type: Metamodel.modelFor(ShopifyLinkedService).name,
    displayName:  stringResources.Shopify_DisplayText,
    linkedServiceKind: 'table',
    icon: {
        className: 'svg-i-100x100-shopify'
    },
    isFirstClass: true,
    supportDatasetV2: true,
    category: ['ServicesApps'],
    isDeprecated: GlobalVariables.showLegacy ? undefined : '{ version !== "v2" }',
    copySinkTypes: [],
    showWarningMessage: '{ version !== "v2" }',
    warningMessage: GlobalVariables.enableShopifyV2 ? format(
        stringResources.Connector_Legacy_IsNotSupportedWarning_alt5,
        stringResources.VersionLabel.toLocaleLowerCase()) : undefined,
    warningMessageHyperlink: 'https://learn.microsoft.com/azure/data-factory/connector-shopify',
    onetimeQueryTemplate: 
    `query <<queryName>> 
    {
        <<tableName>>(first: 250, query: <<filters>>) {
            edges {
                node {
                    <<field1>>
                    <<field2>>
                    ...
                    ...
                }
            }
            pageInfo {
                hasNextPage
                endCursor
            }
        }
    }`,
    copySourceTypes: [Metamodel.modelFor(ShopifyCopySource).name],
    SHIRVersion: GlobalVariables.enableShopifyV2 ? {
        v2: '5.57.0.0'
    } : undefined,
    supportedInTrident: GlobalVariables.tridentBatch1ConnectorPhase2,
    supportOPDG: GlobalVariables.opdgPhase2,
    pqoDataSourceOption: {
        kind: DataSourceOptionKind.Extension,
        resourceKind: 'Shopify' as ResourceKind
    },
    controls: GlobalVariables.enableShopifyV2
        ? [
              {
                  type: 'radio-switch',
                  bind: 'version',
                  label: stringResources.VersionLabel,
                  isLabelVertical: true,
                  required: true,
                  options: driverVersionVersionOptions,
                  defaultValue: driverVersions.v2,
                  hide: GlobalVariables.showLegacy ? false : '{version === "v2" }',
                  cases: [
                      {
                          caseValue: driverVersions.v1,
                          children: [
                            {
                            type: 'hint',
                            hintMode: 'warning',
                            description: format(
                                stringResources.Connector_Legacy_IsNotSupportedWarning_alt6,
                                stringResources.VersionLabel.toLocaleLowerCase()),
                            link: 'https://learn.microsoft.com/azure/data-factory/connector-shopify'
                            },
                            ...connectionForm,
                            useEncryptedEndpointsRadioSwitch
                          ]
                      },
                      {
                          caseValue: driverVersions.v2,
                          children: [...connectionForm]
                      }
                  ]
              },
            ...(connectionForm
                .map((control) => ({
                    ...control,
                    hide: !GlobalVariables.showLegacy ? '{version !== "v2" }' : true
                }))
            )
          ]
        : [
              ...connectionForm,
              useEncryptedEndpointsRadioSwitch
          ]
};
